// extracted by mini-css-extract-plugin
module.exports = {"full-marker-img":"styles_full-marker-img__2gGlx","fullMarkerImg":"styles_full-marker-img__2gGlx","marker-img":"styles_marker-img__GFT2p","markerImg":"styles_marker-img__GFT2p"};